import WidgetSkeleton from "./WidgetSkeleton";
import { useEffect, useState } from "react";
import { Lightbulb, ChevronDown, ChevronUp } from "lucide-react";
import { useRecurringExpenseSuggestionStore } from "../store/useRecurringExpenseSuggestionStore";
import SuggestionCard from "./SuggestionCard";

export default function SuggestionsSection() {
  const { suggestions, isLoading, loadSuggestions } =
    useRecurringExpenseSuggestionStore();
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    loadSuggestions();
  }, []);

  if (isLoading) {
    return <WidgetSkeleton />;
  }

  if (suggestions.length === 0) return null;

  return (
    <div className="rounded-2xl bg-card border border-border shadow-card overflow-hidden">
      <button
        onClick={() => setCollapsed((c) => !c)}
        className="w-full flex items-center justify-between px-5 py-4 hover:bg-muted/40 transition-colors"
      >
        <div className="flex items-center gap-2">
          <div className="w-7 h-7 rounded-lg bg-primary/10 flex items-center justify-center">
            <Lightbulb className="w-3.5 h-3.5 text-primary" />
          </div>
          <span className="text-[13px] font-semibold text-foreground">
            Suggestions
          </span>
          <span className="text-[11px] font-semibold px-1.5 py-0.5 rounded-full bg-primary text-primary-foreground leading-none">
            {suggestions.length}
          </span>
        </div>
        {collapsed ? (
          <ChevronDown className="w-4 h-4 text-muted-foreground" />
        ) : (
          <ChevronUp className="w-4 h-4 text-muted-foreground" />
        )}
      </button>

      {!collapsed && (
        <div className="px-5 pb-5 flex flex-col gap-3">
          <p className="text-[12px] text-muted-foreground -mt-1">
            Recurring patterns detected from your transaction history
          </p>
          {suggestions.map((s) => (
            <SuggestionCard key={s.id} suggestion={s} />
          ))}
        </div>
      )}
    </div>
  );
}
